const UserProfileRow = ({
  profilePictureUrl,
  name,
  email,
  highlight = false,
}: {
  profilePictureUrl?: string;
  name: string;
  email: string;
  highlight?: boolean;
}) => {
  const gradientStyle = {
      background: "linear-gradient(90deg, #EBD197 0%, #C49F42 50%, #EBD197 100%)",
      backgroundSize: "20% 100%",
      backgroundRepeat: "repeat",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
  }

  //text-[#12282A]

  return (
    <>
      <img
        src={profilePictureUrl ?? "/user-default.svg"}
        alt={name}
        width={54}
        height={54}
        className="rounded-full h-14 w-14 object-cover"
      />
      <div className="flex flex-col gap-1 items-start">
      <p className="text-[16px] font-bold truncate max-w-48 text-[#12282A]" style={highlight ? gradientStyle : {}}>{name}</p>
      <p className="text-[16px] text-[#888]">{email}</p>
      </div>
    </>
  );
};

export default UserProfileRow;
